import React from 'react';

const Smiley: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  // Namespace the gradient id per-instance so multiple copies on a page (e.g. a
  // desktop + mobile card) don't share an id; otherwise `url(#id)` resolves to
  // the first match in document order, and a copy in a `display:none` subtree
  // leaves the visible instance with no fill.
  const paint0 = `paint0_radial_smiley_${React.useId().replace(/:/g, '')}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        d="M11.3717 6.38971C12.6338 5.78194 14.0032 5.4287 15.4017 5.35016C16.8003 5.27161 18.2006 5.4693 19.5228 5.93195C20.845 6.39459 22.063 7.11312 23.1075 8.04651C24.152 8.9799 25.0024 10.1099 25.6102 11.3719C26.2179 12.634 26.5712 14.0034 26.6497 15.4019C26.7283 16.8005 26.5306 18.2008 26.0679 19.523C25.6053 20.8451 24.8868 22.0632 23.9534 23.1077C23.02 24.1522 21.89 25.0026 20.6279 25.6103C18.0792 26.8378 15.1472 27.0025 12.477 26.0682C9.80686 25.1339 7.61719 23.1771 6.38974 20.6283C5.16229 18.0796 4.9976 15.1476 5.93191 12.4774C6.86622 9.80725 8.82298 7.61716 11.3717 6.38971Z"
        fill={`url(#${paint0})`}
      />
      <path
        d="M20.4847 20.4846C19.8957 21.0736 19.1966 21.5408 18.4271 21.8596C17.6576 22.1783 16.8328 22.3424 15.9999 22.3424C15.167 22.3424 14.3422 22.1783 13.5727 21.8596C12.8032 21.5408 12.1041 21.0736 11.5151 20.4846"
        stroke="#333333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.2875 13.7407C14.0212 14.0485 13.6943 14.2981 13.3273 14.4739C12.9679 14.6438 12.5831 14.7314 12.1945 14.7314C11.8056 14.7314 11.4208 14.6438 11.0618 14.4739C10.6949 14.2981 10.3682 14.0485 10.1021 13.7407M21.8981 13.7407C21.6318 14.0485 21.305 14.2981 20.9379 14.4739C20.5785 14.6438 20.1937 14.7314 19.8052 14.7314C19.4162 14.7314 19.0314 14.6438 18.6725 14.4739C18.3055 14.2981 17.9788 14.0485 17.7127 13.7407"
        stroke="#4F4F4F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <radialGradient
          id={paint0}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.8455 13.463) rotate(100.954) scale(26.7009 26.7006)"
        >
          <stop stop-color="#FEF772" />
          <stop offset="1" stop-color="#EA873A" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default Smiley;
